import { useAudiencesCRUDActions } from '@mm/state/actions/AudiencesCRUDActions';
import AudiencesModel from '@mm/state/model/AudiencesModel';
import ConnectionModel, {
  ConnectionKind,
} from '@mm/state/model/ConnectionModel';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectAudiences } from '@mm/state/selectors/messengerAdSelectors';
import { Radio, RadioChangeEvent } from 'antd';
import './EditConnectionType.pcss';
import { AudienceSelector } from '../../../../campaigns/components/AudienceSelector/AudienceSelector';
import { selectIsShopifyContext } from '@mm/state/selectors/viewSelectors';

type Props = {
  connection: ConnectionModel;
  chatbotId: number;
  onKindChange: (kind: ConnectionKind) => void;
  onAudienceChange: (audienceId: number) => void;
  onCancel?: () => void;
  isSlideout?: boolean;
  useRowStyle?: boolean;
};

const EditConnectionType = ({
  connection,
  onKindChange,
  onAudienceChange,
  chatbotId,
  isSlideout,
  useRowStyle,
  onCancel,
}: Props) => {
  const audiences = useSelector(selectAudiences);

  const { retrieveAll } = useAudiencesCRUDActions();
  useEffect(() => {
    if (!audiences.length) {
      retrieveAll(chatbotId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const selectedAudience =
    audiences &&
    audiences.find((a: AudiencesModel) => a.id === connection.audienceId);

  const handleKindChange = (e: RadioChangeEvent) => {
    onKindChange(e.target.value);
  };

  const isShopify = useSelector(selectIsShopifyContext);

  return (
    <div className="edit-connection-type">
      <div className="edit-connection-panel__title">Connection Type</div>
      {!isSlideout && (
        <div className="edit-connection-panel__radio-inputs-container">
          <Radio.Group onChange={handleKindChange} value={connection.kind}>
            <Radio
              value={ConnectionKind.AUDIENCE}
              className="edit-connection-type__radio"
            >
              Continuously send contact data from an audience
            </Radio>
            {connection.kind === ConnectionKind.AUDIENCE && (
              <AudienceSelector
                selectedAudienceId={selectedAudience?.id}
                onAudienceSelected={audience => onAudienceChange(audience)}
                className="edit-connection-type__audience"
                onCancel={onCancel}
              />
            )}
            {!isShopify && (
              <Radio
                value={ConnectionKind.WIDGET}
                className="edit-connection-type__radio"
              >
                Send contact data whenever a widget is reached
              </Radio>
            )}
          </Radio.Group>
        </div>
      )}
      {!useRowStyle && !isShopify && (
        <Radio.Group onChange={handleKindChange} value={connection.kind}>
          <Radio
            value={ConnectionKind.WIDGET}
            className="edit-connection-type__radio"
          >
            Send contact data whenever a widget is reached
          </Radio>
        </Radio.Group>
      )}
    </div>
  );
};

export default EditConnectionType;
